(function () {
  'use strict';

  var state = {
    feature: null,
    hasSecond: false,
    slide: 0
  };

  function root() {
    return document.querySelector('[data-gettmi-hero]');
  }

  function config() {
    var node = document.querySelector('[data-gettmi-supabase]');
    if (!node) return null;
    var url = String(node.dataset.supabaseUrl || '').replace(/\/+$/, '');
    var key = String(node.dataset.supabaseKey || '');
    return url && key ? { url: url, key: key } : null;
  }

  function publicUrl(cfg, bucket, path, version, width) {
    if (!cfg || !bucket || !path) return '';
    var url = cfg.url + '/storage/v1/render/image/public/' +
      encodeURIComponent(String(bucket)) + '/' +
      String(path).split('/').map(encodeURIComponent).join('/');
    var params = [
      'width=' + encodeURIComponent(width || 1080),
      'quality=72',
      'resize=cover'
    ];
    if (version) params.push('v=' + encodeURIComponent(version));
    return url + '?' + params.join('&');
  }

  function setSlide(index) {
    var mount = root();
    if (!mount) return;
    var next = index === 1 && state.hasSecond ? 1 : 0;
    state.slide = next;
    mount.querySelectorAll('[data-gettmi-hero-slide]').forEach(function (slide) {
      slide.classList.toggle('is-active', Number(slide.dataset.gettmiHeroSlide) === next);
    });
    var toggle = mount.querySelector('[data-gettmi-toggle-hero]');
    toggle.setAttribute('aria-label', next === 0 ? 'Show next banner' : 'Back to first banner');
    mount.querySelector('[data-gettmi-hero-toggle-vertical]').hidden = next === 1;
    document.body.classList.toggle('gettmi-hero-slide-two', next === 1);
  }

  function hydrate() {
    var mount = root();
    var cfg = config();
    if (!mount || !cfg) return;
    var headers = { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key };
    var banners = window.fetch(
      cfg.url + '/rest/v1/home_banners?' +
        'select=id,slot,image_path,title,alt_text,link_url,sort_order,created_at' +
        '&slot=in.(hero_slide_1,hero_slide_2)&order=slot.asc,sort_order.desc,created_at.desc',
      { headers: headers }
    ).then(function (response) {
      if (!response.ok) throw new Error('banners');
      return response.json();
    });
    var feature = window.fetch(
      cfg.url + '/rest/v1/home_campaign_images?' +
        'select=id,surface,bucket,image_path,title,link_path,sort_order,metadata,updated_at' +
        '&surface=eq.second-banner-feature-1&order=sort_order.asc&limit=1',
      { headers: headers }
    ).then(function (response) {
      if (!response.ok) return [];
      return response.json();
    });

    Promise.all([banners, feature]).then(function (results) {
      var rows = Array.isArray(results[0]) ? results[0] : [];
      var first = rows.find(function (row) { return row.slot === 'hero_slide_1'; });
      var second = rows.find(function (row) { return row.slot === 'hero_slide_2'; });
      if (first && first.image_path) {
        var firstImage = mount.querySelector('[data-gettmi-hero-image-one]');
        firstImage.loading = 'eager';
        firstImage.fetchPriority = 'high';
        var firstUrl = publicUrl(cfg, 'banners', first.image_path, first.id, 1080);
        firstImage.srcset =
          publicUrl(cfg, 'banners', first.image_path, first.id, 824) + ' 824w, ' +
          firstUrl + ' 1080w';
        firstImage.sizes = '100vw';
        firstImage.src = firstUrl;
        firstImage.alt = first.alt_text || first.title || 'GETTMI weekly featured hero';
        if (first.link_url) mount.querySelector('[data-gettmi-hero-link-one]').href = first.link_url;
      }
      if (second && second.image_path) {
        state.hasSecond = true;
        var secondSlide = mount.querySelector('[data-gettmi-hero-slide="1"]');
        var secondImage = mount.querySelector('[data-gettmi-hero-image-two]');
        secondImage.src = publicUrl(cfg, 'banners', second.image_path, second.id, 1080);
        secondImage.alt = second.alt_text || second.title || 'GETTMI second featured hero';
        if (second.link_url) mount.querySelector('[data-gettmi-hero-link-two]').href = second.link_url;
        secondSlide.hidden = false;
        var toggle = mount.querySelector('[data-gettmi-toggle-hero]');
        toggle.disabled = false;
        toggle.setAttribute('aria-disabled', 'false');
      }
      var featureRow = Array.isArray(results[1]) ? results[1][0] : null;
      if (featureRow && featureRow.bucket && featureRow.image_path) {
        state.feature = featureRow;
        var featureButton = mount.querySelector('[data-gettmi-second-banner-feature]');
        var featureImage = mount.querySelector('[data-gettmi-second-banner-feature-image]');
        featureImage.src = publicUrl(
          cfg,
          featureRow.bucket,
          featureRow.image_path,
          featureRow.metadata && featureRow.metadata.asset_version || featureRow.updated_at || featureRow.id,
          240
        );
        featureImage.alt = featureRow.title || 'Featured look';
        featureButton.setAttribute(
          'aria-label',
          'Open ' + (featureRow.metadata && featureRow.metadata.disk_label || featureRow.title || 'featured look')
        );
        featureButton.hidden = false;
      }
    }).catch(function () {
      /* The bundled primary hero remains complete and the handle stays inert. */
    });
  }

  document.addEventListener('click', function (event) {
    var mount = root();
    if (!mount || !event.target.closest) return;
    if (event.target.closest('[data-gettmi-toggle-hero]')) {
      if (!state.hasSecond) return;
      setSlide(state.slide === 0 ? 1 : 0);
      return;
    }
    if (event.target.closest('[data-gettmi-second-banner-feature]') && state.feature) {
      document.dispatchEvent(new CustomEvent('gettmi:open-featured-look', {
        detail: { row: state.feature }
      }));
    }
  });

  function boot() {
    var mount = root();
    if (!mount || mount.dataset.gettmiBooted === 'true') return;
    mount.dataset.gettmiBooted = 'true';
    hydrate();
  }

  boot();
})();
